import React from 'react';
import { List, ListItem, ListItemIcon, ListItemText, Divider, Typography, Box } from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    breadcrumb: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        color: theme.palette.text.primary,
        marginBottom: theme.spacing(1),
    },
    breadcrumbText: {
        marginLeft: theme.spacing(1),
        fontSize: '16px',
    },
    title: {
        fontSize: '24px',
        fontWeight: 'bold',
        margin: `${theme.spacing(1)}px 0 ${theme.spacing(2)}px`,
    },
    menuItemList: {
        display: 'flex',
        flexDirection: 'column',
    },
    menuItem: {
        display: 'flex',
        alignItems: 'center',
        padding: theme.spacing(1, 0),
        cursor: 'pointer',
    },
    iconItemMenu: {
        marginRight: theme.spacing(1),
    },
}));

const PerfilMenu = ({ handleMisDatos }) => {
    const classes = useStyles();

    const handleVolverCatalogo = () => {
        window.location.hash = "/Catalogo"
    }

    return (
        <Box className='menu'>
            <Box className={classes.breadcrumb} onClick={handleVolverCatalogo}>
                <ArrowBack />
                <Typography className={classes.breadcrumbText}>Inicio</Typography>
            </Box>
            <Typography className={classes.title} variant="h4">Mi perfil</Typography>
            <List className={classes.menuItemList}>
                <ListItem button onClick={handleMisDatos} className={classes.menuItem}>
                    <ListItemIcon>
                        <ManageAccountsIcon className={classes.iconItemMenu} />
                    </ListItemIcon>
                    <ListItemText primary='Mis Datos' />
                </ListItem>
                <Divider />
            </List>
        </Box>
    );
}

export default PerfilMenu;
